<template>
  <div>
    <vs-card class="cstm_vx_card mt-1">
      <div slot="header" class="flex flex-wrap justify-between items-center">
        <h4>Files</h4>
        <vs-tooltip text="Add" color="primary">
          <vs-button
            v-if="checkCreatePermission()"
            type="border"
            icon="add"
            color="primary"
            @click="addpopup = !addpopup"
          />
        </vs-tooltip>
      </div>
      <div class="vx-row">
        <vs-table :data="localvalue" class="cstm_vuexy_table w-full">
          <template slot="thead">
            <vs-th sort-key="index">Index</vs-th>
            <vs-th style="min-width: 120px" sort-key="description">Name</vs-th>
            <vs-th style="min-width: 120px" sort-key="size">Size</vs-th>
            <vs-th style="min-width: 120px" sort-key="dateCreated"
              >Date Created</vs-th
            >
            <vs-th style="width: 100px" sort-key="action">Actions</vs-th>
          </template>
          <template>
            <vs-tr :key="indextr" v-for="(item, indextr) in localvalue">
              <vs-td :data="localvalue[indextr].description">
                {{ indextr + 1 }}
              </vs-td>
              <vs-td :data="localvalue[indextr].description">
                {{ localvalue[indextr].description }}
              </vs-td>
              <vs-td :data="localvalue[indextr].file.size">
                {{ localvalue[indextr].file.size }}
              </vs-td>
              <vs-td :data="localvalue[indextr].size">
                {{ now.toLocaleDateString() }}
              </vs-td>
              <vs-td :data="localvalue[indextr]">
                <div class="flex">

                  <vs-dropdown
                    style="float: right; cursor: pointer"
                    vs-custom-content
                    vs-trigger-click
                  >
                    <vs-button
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      icon="icon-more-vertical"
                    ></vs-button>

                    <vs-dropdown-menu>                      
                      <vs-dropdown-item @click="editFile(item)">Edit</vs-dropdown-item>
                      <vs-dropdown-item @click="showDeletePopUp(item, indextr)">Delete</vs-dropdown-item>
                      <vs-dropdown-item @click="downloadItem(item.file.file_path, item.file.file_name)" v-if="item.file.file_path">Download</vs-dropdown-item>
                      <vs-dropdown-item @click="preview(item)" v-if="item.file.file_path">View</vs-dropdown-item>
                    </vs-dropdown-menu>
                  </vs-dropdown>

                  <!-- <vs-button
                    v-if="item.file.file_path"
                    @click="
                      downloadItem(item.file.file_path, item.file.file_name)
                    "
                    icon-pack="feather"
                    class="mr-2"
                    type="filled"
                    icon="icon-download"
                    color="primary"
                  >
                  </vs-button>
                  <vs-button
                    v-if="item.file.file_path"
                    icon-pack="feather"
                    class="mr-2"
                    type="filled"
                    @click="preview(item)"
                    icon="icon-eye"
                    color="primary"
                  />
                  <vs-button
                    class="mr-2"
                    icon-pack="feather"
                    type="filled"
                    @click="editFile(item)"
                    icon="icon-edit"
                    color="primary"
                  />
                  <vs-button
                    class="mr-2"
                    type="filled"
                    @click="remove(item, indextr)"
                    icon="delete"
                    color="danger"
                  /> -->
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vs-card>
    <vs-popup
      classContent="popup-example"
      title="Add File"
      :active.sync="addpopup"
    >
      <form data-vv-scope="file">
        <vs-row>
          <label>Name</label>
          <vs-input
            v-model="description"
            v-validate="'required'"
            style="width: 100%"
            name="name"
            class="custom_Input"
            icon-pack="feather"
            icon="icon-edit"
            icon-after
          />
          <div
            v-if="errors.has('file.name')"
            style="color: red"
            class="invalid-feedback"
          >
            {{ errors.first("file.name") }}
          </div></vs-row
        >
        <vs-row>
          <file-upload-component
            :addpopup="addpopup"
            @getFileId="getFileId"
            types="File"
            :file_repository_id="repository_id"
          ></file-upload-component>
        </vs-row>
      </form>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click.prevent="handleSave">Save</vs-button>
        <vs-button type="border" color="danger" @click="handleAddCancel"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>
    <vs-popup
      classContent="popup-example"
      title="Preview"
      :active.sync="previewPopup"
    >
      <vs-row>
        <div v-if="['jpeg', 'png', 'jpg'].includes(file_type)">
          <img :src="file_url" />
        </div>
        <span v-else>No preview available</span>
      </vs-row>
    </vs-popup>
    <vs-popup
      classContent="popup-example"
      title="Edit Name"
      :active.sync="Editpopup"
    >
      <form data-vv-scope="file_edit">
        <vs-row class="mt-2">
          <label>Name</label>
          <vs-input
            v-validate="'required'"
            v-model="edit.description"
            style="width: 100%"
            name="name"
            class="custom_Input"
            icon-pack="feather"
            icon="icon-edit"
            icon-after
          />
          <div
            v-if="errors.has('file_edit.name')"
            style="color: red"
            class="invalid-feedback"
          >
            {{ errors.first("file_edit.name") }}
          </div>
        </vs-row>
      </form>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click.prevent="handleEdit">Save</vs-button>
        <vs-button type="border" color="danger" @click="handleEditCancel"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>
    <vs-popup
      classContent="popup-example"
      title="Please Confirm"
      :active.sync="showDeletePopUpBool"
    >
      <h4>Are you sure to delete this file?</h4>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click="remove(deleteItem, deleteItemIndex)">Confirm</vs-button>
        <vs-button type="border" color="danger" @click="showDeletePopUpBool = false"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>
  </div>
</template>
<script>
import { PermissionMiddleware } from "../../../mixins/middleware/PermissionMiddleware";
import axios from "axios";
import {
  SinglefileUploadApi,
  SinglefileDeleApi,
  getAllLeadFiles,
} from "@/api/leads";
import FileUploadComponent from "./SinglefileUpload.vue";
import { repository } from "@/mixins/repository.js";
import index from "vue-prism-component";
export default {
  created() {
    this.getRepositoryId(this.module_id);
    this.getLeadFileList();
    const role_permission = parseInt(localStorage.getItem("role_permission"));
    if (role_permission === 1) {
      this.schoolAdmin = true;
    } else {
      this.schoolAdmin = false;

      this.getModulePermission("CRM");
    }
  },
  computed: {
    localvalue: {
      get() {
        return this.leadFiles;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  components: {
    FileUploadComponent,
  },
  mixins: [repository, PermissionMiddleware],
  props: {
    module_id: {
      type: Number,
      required: true,
    },
    lead_id: {
      type: Number,
      required: true,
    },
    leaddetails: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showDeletePopUpBool: false,
      deleteItemIndex: null,
      deleteItem: {},
      Editpopup: false,
      addpopup: false,
      description: "",
      file_id: "",
      previewPopup: false,
      file_url: "",
      file_type: "",
      edit: {},
      files_info: "",
      leadFiles: [],
      now: new Date(),
    };
  },
  methods: {
    showDeletePopUp(item, index) {
      this.deleteItemIndex = index
      this.deleteItem = item
      this.showDeletePopUpBool = true
    },
    async getLeadFileList() {
      try {
        const response = await getAllLeadFiles(this.$route.params.leadId);
        this.leadFiles = response.data.data.lead_file;
      } catch (error) {
        // console.log(error)
      }
    },
    downloadItem(url, label) {
      axios
        .get(url, { responseType: "blob" })
        .then((response) => {
          const blob = new Blob([response.data], { type: "mime" });
          // const blob = new Blob([response.data], { type: 'application/pdf' })

          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `${label}.${
            url.split(".")[url.split(".").length - 1]
          }`;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch(console.error);
    },
    async remove(item, indextr) {
      try {
        const payload = {
          lead_file_id: item.id,
        };
        const deleteFile = await SinglefileDeleApi(payload);
        this.showSuccessMessage(
          "Success",
          "File removed successfully",
          "success"
        );
        //console.log(this.localvalue)
        this.localvalue.splice(indextr, 1);
        this.showDeletePopUpBool = false
        //console.log(this.localvalue)
      } catch (e) {
        this.showSuccessMessage("Warning", "Something went wrong", "warning");
      }
    },
    getFileId(file_id) {
      this.file_id = file_id;
    },
    async handleAddCancel() {
      this.addpopup = false;
      this.description = "";
      this.file_id = "";
    },
    async handleEditCancel() {
      this.Editpopup = false;
    },
    async handleSave() {
      try {
        const validateParent = await this.$validator.validateAll("file");
        //console.log(validateParent)
        if (validateParent && this.file_id) {
          const payload = {
            lead_file_id: null,
            lead_id: this.lead_id,
            description: this.description,
            file_id: this.file_id,
          };
          const fileResponse = await SinglefileUploadApi(payload);
          //console.log(fileResponse)
          this.addpopup = false;
          this.showSuccessMessage(
            "Success",
            "File added successfully",
            "success"
          );
          this.localvalue.unshift(fileResponse.data.data.lead_file);
          this.description = "";
          this.file_id = "";
          //console.log(this.localvalue)
        } else if (this.file_id == "") {
          this.showSuccessMessage("Warning", "Please upload a file", "warning");
        } else {
          this.showSuccessMessage(
            "Warning",
            "Name field is required",
            "warning"
          );
        }
      } catch (e) {
        this.showSuccessMessage("Warning", "Something went wrong", "warning");

        console.log(e);
      }
    },
    async handleEdit() {
      try {
        const validateParent = await this.$validator.validateAll("file_edit");
        if (validateParent) {
          const payload = {
            lead_file_id: this.edit.id,
            lead_id: this.lead_id,
            description: this.edit.description,
            file_id: this.edit.file_id,
          };
          const fileResponse = await SinglefileUploadApi(payload);
          //console.log(fileResponse)
          this.Editpopup = false;
          this.showSuccessMessage(
            "Success",
            "Name updated successfully",
            "success"
          );
        } else {
          this.showSuccessMessage(
            "Warning",
            "Name field is required",
            "warning"
          );
        }
      } catch (e) {
        this.showSuccessMessage("Warning", "Something went wrong", "warning");
      }
    },
    async preview(item) {
      this.file_url = item.file.file_path;
      this.file_type = item.file.file_type
      this.previewPopup = true;
    },
    async editFile(item) {
      this.Editpopup = true;
      this.edit = item;
    },
  },
};
</script>
